import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\BrandController::index
* @see app/Http/Controllers/Company/BrandController.php:20
* @route '/companies/{company}/brands'
*/
export const index = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/companies/{company}/brands',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\BrandController::index
* @see app/Http/Controllers/Company/BrandController.php:20
* @route '/companies/{company}/brands'
*/
index.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return index.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\BrandController::index
* @see app/Http/Controllers/Company/BrandController.php:20
* @route '/companies/{company}/brands'
*/
index.get = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\BrandController::index
* @see app/Http/Controllers/Company/BrandController.php:20
* @route '/companies/{company}/brands'
*/
index.head = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\StoreBrandController::__invoke
* @see app/Http/Controllers/StoreBrandController.php:21
* @route '/companies/{company}/brands'
*/
export const store = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies/{company}/brands',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StoreBrandController::__invoke
* @see app/Http/Controllers/StoreBrandController.php:21
* @route '/companies/{company}/brands'
*/
store.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\StoreBrandController::__invoke
* @see app/Http/Controllers/StoreBrandController.php:21
* @route '/companies/{company}/brands'
*/
store.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

const brands = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
}

export default brands